import {
  Component,
  ComponentRef,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { ComponentPortal } from '@angular/cdk/portal';
import { CarouselInterface } from '../../../../../../photographer-client/src/app/modules/private-sessions/components/private-session-component-carousel/type';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

@Component({
    selector: 'lib-swipeable',
    templateUrl: './swipeable.component.html',
    styleUrls: ['./swipeable.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SwipeableComponent implements OnInit {
  @ViewChild('container', { static: true }) container: ElementRef<HTMLElement>;
  @ViewChild('box2', { static: true }) box2: ElementRef<HTMLElement>;
  @ViewChild('box1', { static: true }) box1: ElementRef<HTMLElement>;
  @Input() component: any;
  box1component: ComponentPortal<CarouselInterface> = null;
  box2component: ComponentPortal<CarouselInterface> = null;
  @Output() componentLoaded = new EventEmitter();
  current;
  disableOnLoad = false;
  reverted = false;
  direction: 'left' | 'right' = null;
  animationInProgress = false;
  @Input() subs: { event: string; listener: (event) => null }[] = [];
  componentChanged$ = new Subject();
  _currentValues = {};
  @Input() set currentValues(values) {
    this._currentValues = values;
    this.patchValues();
  }

  constructor() {}

  patchValues() {
    if (this.current) {
      for (const x in this._currentValues) {
        if (this._currentValues.hasOwnProperty(x)) {
          this.current[x] = this._currentValues[x];
        }
      }
    }
  }

  ngOnInit(): void {
    this.box1component = new ComponentPortal(this.component);
  }

  onComponentRendering(ref) {
    console.log('COMPONENT Loaded');
    ref = ref as ComponentRef<any>;
    if (!this.disableOnLoad) {
      this.componentLoaded.emit(ref);
    }
    this.disableOnLoad = false;
    if (this.reverted) {
      if (this.direction === 'left') {
        this.current.fillNext(ref.instance);
      } else {
        this.current.fillPrev(ref.instance);
      }
    }

    this.current = ref.instance;
    this.attachEvents(ref.instance);
    // this.patchValues();
  }

  attachEvents(instance) {
    for (const event of this.subs) {
      instance[event.event]
        .pipe(
          tap((v) => event.listener(v)),
          takeUntil(this.componentChanged$)
        )
        .subscribe();
    }
  }

  onComponent2Rendering(ref) {
    ref = ref as ComponentRef<any>;
    if (this.direction === 'left') {
      this.current.fillNext(ref.instance);
    } else {
      this.current.fillPrev(ref.instance);
    }
    this.current = ref.instance;
    this.attachEvents(ref.instance);
    // this.patchValues();
  }

  async goLeft() {
    if (this.animationInProgress) {
      return;
    }
    this.animationInProgress = true;
    if (this.reverted) {
      this.box1component = new ComponentPortal(this.component);
    } else {
      this.box2component = new ComponentPortal(this.component);
    }
    if (this.direction === 'right') {
      if (this.reverted) {
        this.box1.nativeElement.style.transform = 'translateX(100%)';
      }
    }
    this.direction = 'left';

    const move = this.container.nativeElement.animate(
      { transform: 'translateX(-50%)' },
      {
        duration: 300,
        iterations: 1,
        direction: 'normal',
      }
    );
    await move.finished;
    // this.box1component.detach();
    // this.box1component = this.box2component;
    this.container.nativeElement.style.transform = 'translateX(0px)';
    this.disableOnLoad = true;
    if (!this.reverted) {
      this.box2.nativeElement.style.transform = 'translateX(-100%)';
      this.box1.nativeElement.style.transform = 'translateX(100%)';
    } else {
      this.box2.nativeElement.style.transform = 'translateX(0%)';
      this.box1.nativeElement.style.transform = 'translateX(0%)';
    }

    this.reverted = !this.reverted;
    this.animationInProgress = false;
    // this.box1.nativeElement.style.transform = 'translateX(100%)';
  }

  async goRight() {
    if (this.animationInProgress) {
      return;
    }
    console.log('go right');
    this.animationInProgress = true;
    if (this.direction === 'left') {
      if (this.reverted) {
        this.box1.nativeElement.style.transform = 'translateX(-100%)';
      } else {
        this.box2.nativeElement.style.transform = 'translateX(-200%)';
        this.box2component = new ComponentPortal(this.component);
      }
    } else {
      if (!this.reverted) {
        this.box2.nativeElement.style.transform = 'translateX(-200%)';
        this.box2component = new ComponentPortal(this.component);
      } else {
        // this.box2.nativeElement.style.transform = 'translateX(0%)';
        // this.box1.nativeElement.style.transform = 'translateX(0%)';
        this.box1component = new ComponentPortal(this.component);
      }
    }

    this.direction = 'right';

    const move = this.container.nativeElement.animate(
      { transform: 'translateX(50%)' },
      {
        duration: 300,
        iterations: 1,
        direction: 'normal',
      }
    );
    await move.finished;
    // this.box1component.detach();
    // this.box1component = this.box2component;
    this.container.nativeElement.style.transform = 'translateX(0px)';
    this.disableOnLoad = true;
    if (!this.reverted) {
      this.box2.nativeElement.style.transform = 'translateX(-100%)';
      this.box1.nativeElement.style.transform = 'translateX(-100%)';
    } else {
      this.box2.nativeElement.style.transform = 'translateX(0%)';
      this.box1.nativeElement.style.transform = 'translateX(0%)';
    }

    this.reverted = !this.reverted;
    this.animationInProgress = false;
    // this.box1.nativeElement.style.transform = 'translateX(100%)';
  }
}
